import { css } from '@emotion/css';

import {
  Colors,
  FontSize,
  FontWeight,
  LineHeight,
} from 'apps/shared/scripts/styles/constants';

export const cardPostClassName = css({
  backgroundColor: Colors.White,
  borderRadius: 4,
  boxShadow: `0px 4px 20px 0px rgba(0, 0, 0, 0.1)`,
  position: 'relative',
});

export const postMediaClassName = css({
  alignItems: 'center',
  borderRadius: '4px 4px 0 0',
  display: 'flex',
  justifyContent: 'center',
  overflow: 'hidden',
  padding: 0,
});

export const imageClassName = css({
  borderRadius: 0,
  width: '100%',
});

export const postMessageClassName = css({
  padding: '18px 18px 0 18px',
  marginBottom: '-4px',
});

export const paragraphClassName = css({
  color: Colors.Primary,
  fontFamily: `'Nunito', sans-serif`,
  fontSize: FontSize.REGULAR,
  fontWeight: FontWeight.SEMI_BOLD,
  lineHeight: LineHeight.LARGE,
});

export const postProfileClassName = css({
  alignItems: 'center',
  display: 'flex',
  padding: '16px 18px',
});

export const profileMetaClassName = css({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  marginLeft: 'auto',
});

export const metaNameClassName = css({
  color: Colors.Primary,
  display: 'block',
  fontFamily: `'Nunito', sans-serif`,
  fontSize: FontSize.REGULAR,
  fontWeight: FontWeight.SEMI_BOLD,
});

export const postActionsClassName = css({
  position: 'absolute',
  bottom: 20,
  left: 4,
});

export const rowClassName = css({
  alignItems: 'center',
  display: 'flex',
});

export const iconClassName = css({
  transition: '0.2s',
});

export const rotatedIconClassName = css({
  transform: `rotate(-90deg)`,
});

export const buttonClassName = css({
  margin: '0 14px',
  padding: 0,
  '&::before': {
    content: '""',
    display: 'block',
    borderRadius: '50%',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    height: 34,
    width: 34,
  },
  '&:hover, &:active': {
    '&::before': {
      background: 'rgba(66, 79, 96, 0.05)',
    },
  },
});

export const infoClassName = css({
  color: '#22b2da',
  '&::before': {
    background: 'rgba(34, 178, 218, 0.05)',
  },
  '&:hover::before': {
    background: 'rgba(34, 178, 218, 0.1)',
  },
});

export const dangerClassName = css({
  color: '#ff5151',
  '&::before': {
    background: 'rgba(255, 81, 81, 0.05)',
  },
  '&:hover::before': {
    background: 'rgba(255, 81, 81, 0.1)',
  },
});
